<script setup lang="ts">
import { computed, onMounted } from 'vue';
import DxDataGrid, {
  DxColumn,
  DxEditing,
  DxLookup,
  DxScrolling,
  DxSorting,
  type DxDataGridTypes,
} from 'devextreme-vue/data-grid';
import { bottoGridPaging } from '@botto/core';
import { getDirectionsLookup } from '../../lookups';
import { createAggregatorDirectionsStore } from '../../api';
import { ENCODING_MODE_ITEMS } from '../../constants/encodingMode';

const { paging, pager } = bottoGridPaging({ pageSize: 20 });

const props = defineProps<{
  aggregatorId: number;
}>();

const directionsLookup = getDirectionsLookup();
const store = computed(() => createAggregatorDirectionsStore(props.aggregatorId));

const currencyItems = ['RUB', 'USD', 'EUR', 'KZT', 'UZS', 'BYN', 'UAH', 'GBP'];
const encodingModeItems = ENCODING_MODE_ITEMS;

function directionDisplay(item: { id: number }) {
  return directionsLookup.labelOf(item.id);
}

function onInitNewRow(e: DxDataGridTypes.InitNewRowEvent) {
  e.data.aggregator_id = props.aggregatorId;
  e.data.currency = 'RUB';
  e.data.encoding_mode = null;
}

onMounted(() => {
  void directionsLookup.ensureLoaded();
});
</script>

<template>
  <div class="agg-directions">
    <div class="agg-directions__title">Направления агрегатора</div>
    <DxDataGrid
      :data-source="store"
      key-expr="direction_id"
      :show-borders="true"
      :column-auto-width="true"
      :repaint-changes-only="true"
      :hover-state-enabled="true"
      :paging="paging"
      :pager="pager"
      @init-new-row="onInitNewRow"
    >
      <DxEditing
        :allow-adding="true"
        :allow-updating="true"
        :allow-deleting="true"
        mode="row"
        :use-icons="true"
      />
      <DxColumn
        data-field="direction_id"
        caption="Направление"
        :calculate-display-value="(row: any) => directionsLookup.labelOf(row.direction_id)"
      >
        <DxLookup
          :data-source="directionsLookup.items.value"
          value-expr="id"
          :display-expr="directionDisplay"
        />
      </DxColumn>
      <DxColumn data-field="currency" caption="Валюта" :width="120">
        <DxLookup :data-source="currencyItems" />
      </DxColumn>
      <DxColumn data-field="encoding_mode" caption="Тип кодировки" :width="220">
        <DxLookup
          :data-source="encodingModeItems"
          value-expr="value"
          display-expr="text"
        />
      </DxColumn>
      <DxScrolling mode="standard" />
      <DxSorting mode="single" />
    </DxDataGrid>
  </div>
</template>

<style scoped>
.agg-directions {
  padding: 16px 20px 20px;
  background: var(--dx-color-main-bg, #fff);
}

.agg-directions__title {
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 10px;
  color: var(--dx-color-text-secondary, #555);
}
</style>
